import { render, staticRenderFns } from "./DoctorSpecialityFilters.vue?vue&type=template&id=5bdb63cf&"
import script from "./DoctorSpecialityFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorSpecialityFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bdb63cf')) {
      api.createRecord('5bdb63cf', component.options)
    } else {
      api.reload('5bdb63cf', component.options)
    }
    module.hot.accept("./DoctorSpecialityFilters.vue?vue&type=template&id=5bdb63cf&", function () {
      api.rerender('5bdb63cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/DoctorSpecialityFilters/DoctorSpecialityFilters.vue"
export default component.exports